interface LlmGatewayResponse {
  choices: {
    message: {
      content: string
    }
  }[]
}

export async function callLlmGateway(
  systemPrompt: string,
  userPrompt: string,
): Promise<string> {
  try {
    const response = await fetch(process.env.REACT_APP_LLM_GATEWAY_URL || '', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_LLM_GATEWAY_APIKEY || ''}`,
      },
      body: JSON.stringify({
        model: 'gpt-4.1-nano',
        messages: [
          {
            role: 'developer',
            content: systemPrompt,
          },
          {
            role: 'user',
            content: userPrompt,
          },
        ],
      }),
    })

    if (!response.ok) {
      throw new Error('Erro na chamada da API LLM Gateway')
    }

    const result: LlmGatewayResponse = await response.json()
    return result.choices[0]?.message?.content || ''
  } catch (error) {
    console.error('Erro ao chamar LLM Gateway:', error)
    throw error
  }
}
